import {ReactNode} from "react";

export const AutoLinkNone = ({children}: {children: ReactNode[]}) => {
    return <span>{children}</span>;
};
